import styled from 'styled-components';
import { transparentize } from 'polished';
import { Img } from 'react-image';
import { Form as FormBase } from '@unform/web';
import { CircularProgressbar } from 'react-circular-progressbar';
import { ButtonBase } from 'components/Button/styles';
import { Table as GlobalTable } from 'styles/global';

import { device } from 'styles/device';
import { FlagProps } from 'components/Flag';

interface TdFlagProps {
  size?: number;
  type: FlagProps['type'];
  hasMidia: boolean;
  avaliadaeng?: boolean;
}
interface ColumnContentProps {
  columns: string;
  margin?: string;
}
interface DropContainerProps {
  isDragActive: boolean;
  isDragReject: boolean;
}
interface ThumbnailContainerProps {
  $mini?: boolean;
  inUpload: boolean;
  disabled?: boolean;
  hasMidia?: boolean;
}
interface ButtonUploadProps {
  hasMidia: boolean;
}
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;

  header {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    ${ButtonBase} {
      &:first-of-type {
        margin-right: 10px;
      }
    }

    button {
      svg {
        margin-left: 5px;
      }
    }

    h4 {
      min-width: 130px;
    }
  }
`;

export const WidgetContent = styled.div`
  flex-grow: auto;
  display: flex;
  margin-bottom: 10px;
`;

export const Content = styled.div`
  padding: 0 15px 0 15px;
  flex: 1 1;
`;

export const FormContent = styled.div`
  flex: 1 1;
`;
export const FormActions = styled.div`
  display: flex;
  /* justify-content: space-between; */
  button {
    margin: 0 5px;
  }
  div {
    display: flex;
  }
`;
export const Table = styled(GlobalTable)`
  th,
  td {
    &:nth-of-type(1) {
      width: 1.2rem;
    }
    &:nth-of-type(3) {
      > div {
        margin-left: 18px;
      }
      width: 185px;
      text-align: center;
    }
    &:nth-of-type(4) {
      width: 100px;
      text-align: center;
    }
    &:nth-of-type(5),
    &:nth-of-type(6) {
      width: 120px;
      text-align: center;
    }
    &:last-of-type {
      text-align: center;
      width: 1rem;
    }
  }
`;
export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  section {
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};

    &:first-of-type {
      margin: 0px 0 15px 0;
    }

    ${ButtonBase} {
      margin-top: -10px;
    }
  }
`;

export const ColumnContent = styled.div<ColumnContentProps>`
  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-template-columns: ${props => props.columns};
  grid-column-start: 1;
  grid-column-end: 2;
  margin-bottom: 10px;
  height: 100%;
  @media ${device.laptopM} {
    grid-template-columns: 1fr;
  }

  > div {
    margin-right: 10px;
    margin: ${props => props.margin};
  }
  section {
    display: flex;
    justify-content: space-between;

    padding: 0 0 5px 0 !important;
    margin-bottom: 15px;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};

    &:first-of-type {
      margin: 0px 0 15px 0;
    }

    ${ButtonBase} {
      margin-top: -10px;
    }
  }
`;
export const ButtonUpload = styled.button<ButtonUploadProps>`
  position: absolute;
  border: 0;
  padding: 0;
  margin: 0%;
  transition: all 0.2s ease;
  opacity: 0;
  display: flex;
  align-items: center;

  /* margin-left: -15px; */
  border-radius: 15px;
  padding: 6px 6px;

  background-image: linear-gradient(
    to bottom left,
    ${props => props.theme.button.primary.out},
    ${props => props.theme.button.primary.in},
    ${props => props.theme.button.primary.out}
  ) !important;
  background-color: ${props => props.theme.button.primary.out};
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  svg {
    color: #fff;
    font-size: 24px;
  }

  p {
    color: #fff;
    margin-left: 5px;
  }
`;

export const ButtonUploadError = styled.button<ButtonUploadProps>`
  position: absolute;
  border: 0;
  padding: 0;
  margin: 0%;
  transition: all 0.3s ease;
  opacity: 0;
  display: flex;
  align-items: center;

  /* margin-left: -15px; */
  border-radius: 15px;
  padding: 6px 6px;

  background-image: linear-gradient(
    to bottom left,
    ${props => props.theme.button.danger.out},
    ${props => props.theme.button.danger.in},
    ${props => props.theme.button.danger.out}
  ) !important;
  background-color: ${props => props.theme.button.danger.out};
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  svg {
    color: #fff;
    font-size: 24px;
  }

  p {
    color: #fff;
    margin-left: 5px;
  }

  ${ButtonUpload} {
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const Upload = styled.div`
  display: flex;
  position: relative;
  padding: 0 15px;
  justify-content: center;
  align-items: center;
  &:hover ${ButtonUpload} {
    opacity: 1;
  }
`;

export const TdFlag = styled.td<TdFlagProps>`
  width: ${props => props.size + 'rem'};
  font-size: 1.0625rem;
  color: ${props => props.theme.fontColor};
  padding: 0 !important;

  div {
    margin-right: 5px;
    width: 10px;
    height: 40px;
    background-color: ${props => props.theme.flag[props.type]};
    ${props => (!props.hasMidia || props.avaliadaeng ? 'opacity: 0.3' : '')}
  }
`;
export const DropContainer = styled.div<DropContainerProps>`
  ${ButtonUpload} {
    opacity: ${props => (props.isDragActive ? '1' : '0')};
  }

  ${ButtonUploadError} {
    opacity: ${props => (props.isDragReject ? '1' : '0')};
  }
`;

export const ThumbnailContainer = styled.div<ThumbnailContainerProps>`
  position: relative;
  min-width: 200px;

  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: auto;
    max-width: ${props => (props.$mini ? '200px' : '350px')};

    border-radius: 5px !important;
    cursor: ${props => (props.inUpload ? 'default' : 'pointer')};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    transition: all 0.25s ease;
    filter: ${props =>
      props.inUpload ? 'blur(1px) grayscale(100%)' : 'blur(0px)'};
    &:hover {
      opacity: 1;
      transform: scale(1.1);
    }
  }

  svg {
    /* position: absolute !important; */
  }
`;

export const Image = styled(Img)``;

export const CircularContainer = styled(CircularProgressbar)`
  position: absolute;
  opacity: 1;
`;

export const FileContent = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  align-items: center;
  .headphones {
    width: 100px;
    height: 100px;
    svg {
      font-size: 48px;
    }
  }
`;
